<div
  class="card d-inline-flex flex-row align-items-center hover mx-1 px-2 py-1"
>
  <i class="bi bi-folder-fill h5 my-auto mx-1"></i>
  <h5 class="my-auto mx-2 py-1">{{ name }}</h5>
</div>
